import React, {useState} from 'react';
import PropTypes from 'prop-types';
import {reduxForm} from 'redux-form';
import {Button, Grid} from 'semantic-ui-react';

import Form from '@appComponents/ReduxFormControls';
import * as Buttons from '@appComponents/ButtonCollection';
import {convertToInt} from '@utils/helpers';
import {hasPrivileges} from '@appComponents/Authorization';
import {THIRD_PARTY_CLIENT_TUNNEL} from '@constants/resources';
import {SECURITY_PRIVILEGES_READ, SECURITY_PRIVILEGES_UPDATE} from '@constants/variables';

import validate from './validatorClientOutputClientReference';

const ClientOutputClientReferenceForm = (props) => {
    const {
        formType,
        formData,
        references,
        setReferences,
        onDeactivateEditableCell,
        variables,
    } = props;
    const authorization = {
        update: hasPrivileges({[THIRD_PARTY_CLIENT_TUNNEL]: SECURITY_PRIVILEGES_UPDATE}),
        add: hasPrivileges({[THIRD_PARTY_CLIENT_TUNNEL]: SECURITY_PRIVILEGES_READ}),
    };

    const [fields, setFields] = useState({output_reference: '', description: ''});

    const handleFieldChange = (field, e, value) => {
        const newValue = e?.target?.value || value || '';

        setFields(prev => ({...prev, [field]: newValue}));
    };

    const validateFields = () => {
        return (
            !fields.output_reference ||
            100 < fields.output_reference.length ||
            200 < fields.description.length
        );
    };

    const handleAddReference = (e) => {
        e.preventDefault();

        if (validateFields()) return;

        const newItem = {
            output_reference: fields.output_reference,
            description: fields.description,
        };

        setReferences([...references, newItem]);
        setFields({output_reference: '', description: ''});
    };

    const handleUpdateReference = (e, id) => {
        e.preventDefault();

        if (validateFields()) return;

        const updated = references.map((ref, idx) => {
            return idx === convertToInt(id) ? {
                ...ref,
                output_reference: fields.output_reference,
                description: fields.description,
            } : ref;
        });

        setReferences(updated);
        onDeactivateEditableCell();
    };

    const renderClientTunnelReferenceInput = (formType, handleFieldChange, addPath) => {
        const isAddForm = 'form_ref_add' === formType;
        let showForm;

        if (!addPath) {
            showForm = !authorization.update;
        } else {
            showForm = !authorization.add;
        }

        const commonProps = {
            className: '--align-self-baseline --long-width',
            allowClear: true,
            component: Form.SemanticInput,
            hidden: showForm,
            autoFocus: false,
        };

        return (
            <Grid verticalAlign='top'>
                <Grid.Row>
                    {!isAddForm && (
                        <Grid.Column width={2}></Grid.Column>
                    )}
                    <Grid.Column width={isAddForm ? 8 : 6} className={'--no-padding-right'}>
                        <Form.FormRow
                            {...commonProps}
                            name={isAddForm ? 'output_client_references' : 'output_client_references_edit'}
                            label={isAddForm ? 'Output client references' : null}
                            className={isAddForm ? '--align-self-baseline --medium-width' : '--align-self-baseline reference-column-edit'}
                            placeholder={'Reference'}
                            onChange={(e, val) => handleFieldChange('output_reference', e, val)}
                            defaultValue={fields?.output_reference || formData?.fields?.output_reference || ''}
                            placeholderText={'Reference'}

                        />
                    </Grid.Column>
                    <Grid.Column width={6}>
                        <Form.FormRow
                            {...commonProps}
                            name={isAddForm ? 'output_client_description' : 'output_client_description_edit'}
                            placeholder={'Description'}
                            onChange={(e, val) => handleFieldChange('description', e, val)}
                            defaultValue={fields?.description || formData?.fields?.description || ''}
                            placeholderText={'Description'}
                        />
                    </Grid.Column>
                    {!showForm && (
                        <Grid.Column width={2}>
                            {renderButtons(formType)}
                        </Grid.Column>
                    )}
                </Grid.Row>
            </Grid>
        );
    };

    const renderButtons = (formType) => {
        if ('form_ref_add' === formType) {
            return (
                <Buttons.ButtonAdd
                    onClick={handleAddReference}
                >
                    Add
                </Buttons.ButtonAdd>
            );
        } else {
            return (
                <Button.Group>
                    {fields && <Button
                        data-id={formData?.id}
                        data-testid='save-button'
                        icon='checkmark'
                        key='update-button'
                        positive
                        onClick={(e) => handleUpdateReference(e, formData?.id)}
                    />}
                    <Button
                        data-cancel-id={formData?.id}
                        data-testid='cancel-button'
                        icon='ban'
                        key='cancel-button'
                        negative
                        onClick={onDeactivateEditableCell}
                    />
                </Button.Group>
            );
        }
    };

    return (
        <>
            {renderClientTunnelReferenceInput(formType, handleFieldChange, variables?.addPath)}
        </>
    );
};

ClientOutputClientReferenceForm.propTypes = {
    formType: PropTypes.string,
    formData: PropTypes.object,
    variables: PropTypes.object,
    references: PropTypes.func,
    setReferences: PropTypes.func,
    onDeactivateEditableCell: PropTypes.func,
};

const ClientOutputClientReferenceFormRedux = reduxForm({
    form: 'ClientOutputClientReferenceForm',
    validate: validate,
})(ClientOutputClientReferenceForm);

export default ClientOutputClientReferenceFormRedux;
